import { jsx } from 'react/jsx-runtime';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { useResourceDataContextSafe } from '../../../../resource-detail/components/context/resourceDataContext.js';
import { styled, css } from 'styled-components';

const ColorLabel = ({ absPosition }) => {
  const { resource, parentColorLabels } = useResourceDataContextSafe();
  if (!parentColorLabels || !resource.label) return null;
  const color = parentColorLabels.find((item) => item.id === resource.label?.id)?.hexColor;
  if (!color) {
    return null;
  }
  return /* @__PURE__ */ jsx(ColorLabelRaw, {
    absPosition,
    style: {
      background: color
    }
  });
};
const ColorLabelRaw = styled.div.withConfig({
  displayName: "ColorLabel__ColorLabelRaw",
  componentId: "sc-5f6aaa1b-0"
})([
  `height:0.5rem;width:0.5rem;border-radius:50%;position:absolute;left:-1.5rem;top:50%;transform:translateY(-50%);z-index:10;outline:2px solid `,
  `;`,
  ` `,
  ``
], cssVar["color-bg-primary"], (p) => p.absPosition === "inside-top-left" && css([
  `top:0.875rem;right:0.6125rem;left:auto;bottom:auto;`
]), (p) => p.absPosition === "disabled" && css([
  `position:static;transform:none;`
]));

export { ColorLabel, ColorLabelRaw };
//# sourceMappingURL=ColorLabel.js.map
